// Basic
import MetalClient, { envTypes, catalog } from '@atlassiansox/metal-client';
import { Environment, ENV_DEV, ENV_STAGING } from '@atlassiansox/bxpkit-core';
import { getDevopsTimeToInteractive } from './performance';

import packageJson from '../../package.json';

const productInfo = {
  metalId: '04e59420-3f82-40ee-acd2-44ceb2faeb68', // include your Metal ID
  version: packageJson.version, // The version of your application
  env: envTypes.PROD // env should be the env of your application else use Prod
};

if (Environment.getEnvironment() === ENV_DEV) {
  productInfo.env = envTypes.DEV;
} else if (Environment.getEnvironment() === ENV_STAGING) {
  productInfo.env = envTypes.STAGING;
}

export const metalClient = new MetalClient({ productInfo });

export function submitDevopsTimeToInteractive() {
  const devopsTTI = getDevopsTimeToInteractive();
  console.log(`devopsTTI ${devopsTTI}`);

  metalClient.metric.submit({
    name: catalog.performance.COMPONENT_INTERACTIVE,
    value: getDevopsTimeToInteractive(),
    page: 'signUp',
    component: 'signUp'
  });
}
